import { ReactNode } from 'react';

import { cx } from '@libs/classnames';

import styles from './Layout.module.css';

export type Props = {
  className?: string;
  header?: ReactNode;
  children: ReactNode;
};
export function Layout({ className, header, children }: Props) {
  return (
    <div className={cx(styles.layout, className)}>
      {header}
      <div className={styles.innerContainer}>{children}</div>
    </div>
  );
}
